import PropTypes from 'prop-types';
import { memo, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import * as DatePresets from 'UIComponents/dates/dateRangePresets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDateRange from 'UIComponents/dates/UIDateRange';
import I18n from 'I18n';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import { fromMoment, toMomentUTC } from 'UIComponents/core/SimpleDate';
import SingleFilterSelect from './SingleFilterSelect';
import { convertDateRangeToPresetId, CustomDatePresets, DATE_RANGES } from '../../util/DateRangeConverter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OPTIONS = DATE_RANGES.map(dateRange => ({
  text: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `app.filter.panel.dateRange.options.${dateRange.presetId}`
  }),
  value: dateRange.presetId
}));
function DateRangeSelect(props) {
  const dateRange = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters.dateRange);
  const defaultValue = useMemo(() => convertDateRangeToPresetId(dateRange), [dateRange]);
  const [isCustomDate, setCustomDate] = useState(isDefaultValueCustomRange(defaultValue));
  function isDefaultValueCustomRange(date) {
    return date === CustomDatePresets.CUSTOM_DATE_RANGE.presetId;
  }
  function getDefaultValueForCustomRange() {
    return isDefaultValueCustomRange(defaultValue) ? {
      startDate: fromMoment(I18n.moment(parseInt(dateRange.startDate, 10))),
      endDate: fromMoment(I18n.moment(parseInt(dateRange.endDate, 10)))
    } : {
      startDate: 0,
      endDate: 0
    };
  }
  function handlePresetChange(value) {
    if (value === CustomDatePresets.CUSTOM_DATE_RANGE.presetId) {
      setCustomDate(true);
    } else {
      handleCustomChange(value in CustomDatePresets ?
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      CustomDatePresets[value].getValue('utc') :
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      DatePresets[value].getValue('utc'));
      setCustomDate(false);
    }
  }
  function handleCustomChange(value) {
    if (value.endDate && value.startDate) {
      props.onSelect({
        endDate: toMomentUTC(value.endDate).valueOf(),
        startDate: toMomentUTC(value.startDate).valueOf()
      });
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SingleFilterSelect, {
      "data-test-id": "filter-select",
      labelLangPath: "app.filter.panel.dateRange.label",
      onSelect: handlePresetChange,
      options: OPTIONS
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Requireab... Remove this comment to see the full error message
      ,
      defaultValue: defaultValue
    }), isCustomDate ? /*#__PURE__*/_jsx(UIDateRange, {
      className: "m-top-2",
      "data-test-id": "custom-date-range-picker",
      defaultValue: getDefaultValueForCustomRange(),
      onChange: ({
        target: {
          value
        }
      }) => handleCustomChange(value),
      showPresets: false,
      tz: "utc"
    }) : null]
  });
}
DateRangeSelect.propTypes = {
  onSelect: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(DateRangeSelect);